/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import Localized from '../../../shared/components/Localized';


import LandingPageDataTable from '../../components/LandingPageDataTable';
const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;

  `;
const HealthyImage = styled.img.attrs({
    src: '/assets/icons/Healthy3.svg#Layer_1',
    alt: 'No ongoing maintenance windows'
  })`
  width: 268px;
  height: 124px;
`;
const HealthyStatusMessage = styled.p`
  margin-top: 16px;
  font-family: "Salesforce Sans",Arial,sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: justify;
  color: #16325c;
  align-self: center;
  @media (min-width: 1024px) {
    margin-bottom: 55px;
  }
  @media (min-width: 768px) and (max-width: 1024px){
    margin-bottom: 73px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
      margin-bottom: 212px;
  }
`;
class LandingPageMaintenanceList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { bucketedList } = this.props;
    const bucketVal = bucketedList.buckets[0].rows.length > 0;
    return (
       <div>
        {bucketVal &&  <LandingPageDataTable
          bucketedList={bucketedList}
        />
        }
        {!bucketVal &&
         <ImageWrapper>
          <HealthyImage></HealthyImage>
          <HealthyStatusMessage><Localized modelName={'landingPage'} modelKey={'maintenanceList'} modelAttribute={'text'}/></HealthyStatusMessage>
          </ImageWrapper>
          }
      </div>
        );
      }
    }
    export default LandingPageMaintenanceList;
